import { Trash2, Merge } from 'lucide-react';
import { TranscriptionSegment } from '@/hooks/useTranscription';
import { TimeInput } from './TimeInput';

interface SegmentRowProps {
  segment: TranscriptionSegment;
  onChange: (updates: Partial<TranscriptionSegment>) => void;
  onDelete?: () => void;
  onMergeWithPrevious?: () => void;
  isFirst?: boolean;
  disabled?: boolean;
}

/**
 * 單一字幕段落編輯列
 */
export function SegmentRow({
  segment,
  onChange,
  onDelete,
  onMergeWithPrevious,
  isFirst,
  disabled,
}: SegmentRowProps) {
  return (
    <div className="flex items-start gap-4 p-4 border-2 border-black rounded-xl bg-white hover:shadow-[4px_4px_0_#1A1A1A] transition-all mb-1">
      {/* 序號 */}
      <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-[#4DA6FF] border-2 border-black rounded-lg font-bold text-lg shadow-[2px_2px_0_#1A1A1A]">
        {segment.id}
      </div>

      {/* 時間碼 */}
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-2">
          <span className="text-[10px] font-bold text-gray-400 uppercase tracking-tighter w-8">開始</span>
          <TimeInput
            value={segment.start}
            onChange={(start) => onChange({ start })}
            disabled={disabled}
            className="w-32"
          />
        </div>
        <div className="flex items-center gap-2">
          <span className="text-[10px] font-bold text-gray-400 uppercase tracking-tighter w-8">結束</span>
          <TimeInput
            value={segment.end}
            onChange={(end) => onChange({ end })}
            disabled={disabled}
            className="w-32"
          />
        </div>
      </div>

      {/* 文字輸入 */}
      <textarea
        value={segment.text}
        onChange={(e) => onChange({ text: e.target.value })}
        disabled={disabled}
        rows={2}
        className="
          flex-1 px-4 py-2 border-2 border-black rounded-xl bg-white resize-none text-lg leading-relaxed
          focus:outline-none focus:ring-2 focus:ring-[#FF6B9D] focus:ring-offset-2
          disabled:bg-gray-100 disabled:text-gray-500 transition-all
        "
        placeholder="字幕文字..."
      />

      {/* 操作按鈕 */}
      <div className="flex flex-col gap-1">
        {!isFirst && onMergeWithPrevious && (
          <button
            onClick={onMergeWithPrevious}
            disabled={disabled}
            className="
              w-8 h-8 flex items-center justify-center
              border-2 border-black rounded-lg bg-white
              hover:bg-[#FFD93D] transition-colors
              disabled:opacity-50 disabled:cursor-not-allowed
            "
            title="合併到上一段"
          >
            <Merge className="w-4 h-4" />
          </button>
        )}
        {onDelete && (
          <button
            onClick={onDelete}
            disabled={disabled}
            className="
              w-8 h-8 flex items-center justify-center
              border-2 border-black rounded-lg bg-white
              hover:bg-[#FF6B9D] transition-colors
              disabled:opacity-50 disabled:cursor-not-allowed
            "
            title="刪除"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );
}
